import Swiper from "swiper/bundle";
import Vimeo from "@vimeo/player";
import { MobileDetect } from "@/scripts/utils";

class HeroCarousel extends window.HTMLElement {
  constructor() {
    super();

    this.id = this.getAttribute("id");
    this.wrapper = `#shopify-section-${this.id} .hero-carousel`;
    this.swiper = `${this.wrapper} .swiper`;

    new Swiper(this.swiper, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      loopAdditionalSlides: 2,
      observer: true,
      observeParents: true,
      on: {
        beforeInit: (swiper) => {
          if (!MobileDetect.isApp && swiper?.wrapperEl) {
            const appOnlySlides = swiper.wrapperEl.querySelectorAll(
              ".swiper-slide--app-only"
            );

            appOnlySlides.forEach((slide) => {
              slide.remove();
            });
          }
        },
        slideChangeTransitionStart: (swiper) => {
          if (!swiper?.wrapperEl) return;

          const videos = swiper.wrapperEl.querySelectorAll(
            ".swiper-slide--video"
          );

          if (videos && videos.length > 0) {
            const isMobile = window.matchMedia("(max-width: 1024px)").matches;

            videos.forEach((video) => {
              const player = new Vimeo(video);

              if (isMobile) {
                if (video.classList.contains("swiper-slide-active")) {
                  player.play();
                } else {
                  player.pause();
                }
              } else {
                if (
                  video.classList.contains("swiper-slide-active") ||
                  video.classList.contains("swiper-slide-next")
                ) {
                  player.play();
                } else {
                  player.pause();
                }
              }
            });
          }
        },
      },
      pagination: {
        el: `${this.wrapper} .swiper-pagination`,
        type: "custom",
        renderCustom: function renderCustom(e, t, n) {
          if (t < 10) {
            t = "0" + t;
          }
          if (n < 10) {
            n = "0" + n;
          }
          return '<div class="number-paging"><span class="hidden">현재 배너</span><span class="swiper-pagination-current">'
            .concat(
              t,
              '</span><span class="swiper-pagination-separator"> / </span><span class="hidden">전체 배너</span><span class="swiper-pagination-total">'
            )
            .concat(n, "</span></div>");
        },
      },
      navigation: {
        nextEl: `${this.wrapper} .swiper-button-next`,
        prevEl: `${this.wrapper} .swiper-button-prev`,
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
        1280: {
          slidesPerView: 2,
          slidesPerGroup: 1,
        },
      },
    });
  }
}

window.customElements.define("hero-carousel", HeroCarousel);
